import { differenceInMinutes, format, isMonday, isValid, parse, previousMonday, setHours, setMinutes, setSeconds } from 'date-fns/esm';
import Booking from '../types/model/Booking';
import { DATE_FORMAT_EU, DATE_FORMAT_HOURS_MINUTES } from '../constants/date';

export function getDefaultDate() {
  return new Date(1970, 1, 1, 0, 0, 0, 0);
}

export function isValidDate(d: unknown) {
  return d instanceof Date && !Number.isNaN(d as unknown as number);
}

export function getMondayOfWeek(date = new Date()): Date {
  date.setHours(0, 0, 0, 0);

  if (isMonday(date)) {
    return date;
  }

  return previousMonday(date);
}

export function getTimeDate(timeHHMMSS?: string) {
  let date = getDefaultDate();
  if (!timeHHMMSS) {
    return date;
  }
  const [hours, minutes, seconds] = timeHHMMSS.split(':');

  if (hours !== undefined) {
    date = setHours(date, Number(hours));
  }
  if (minutes !== undefined) {
    date = setMinutes(date, Number(minutes));
  }
  if (seconds !== undefined) {
    date = setSeconds(date, Number(seconds));
  }

  return isValid(date) ? date : getDefaultDate();
}

export function getDurationInMinutes(startTime: string, endTime: string) {
  const startTimeDate = parse(startTime, 'H:mm:ss', getDefaultDate());
  const endTimeDate = parse(endTime, 'H:mm:ss', getDefaultDate());
  return differenceInMinutes(startTimeDate, endTimeDate);
}

export function formatBookingDuration(booking: Booking): string {
  const startTime = format(getTimeDate(booking.startTime), DATE_FORMAT_HOURS_MINUTES);
  const endTime = format(getTimeDate(booking.endTime), DATE_FORMAT_HOURS_MINUTES);
  return `${startTime} - ${endTime}`;
}

export function formatDate(date: Date, dateFormat = DATE_FORMAT_EU): string {
  return format(date, dateFormat);
}

export function differenceInMinutesToCurrentTime(time: string): number {
  const [hours, minutes] = time.split(':');

  const currentTime = new Date();
  const providedTime = new Date();
  providedTime.setHours(Number(hours));
  providedTime.setMinutes(Number(minutes));

  return differenceInMinutes(currentTime, providedTime);
}
